import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';
import styled from 'styled-components';

type SubNavbarWrapperProps = {
  isNavbarHidden?: boolean;
};

export const SubNavbarWrapper = styled.div<SubNavbarWrapperProps>`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: auto;

  @media (min-width: 992px) {
    &.marginTopExclusionTopBanner {
      margin-top: 40px;
    }
    &.marginTopExclusionTopBannerMedium {
      margin-top: 84px;
    }
    &.marginTopExclusionTopBannerMax {
      margin-top: 104px;
    }
  }

  ${media.desktop`
    flex-flow: row nowrap;
    /* Forces the nav to big as height as the page content. */
    align-items: stretch;
  `}
`;

export const WithBannerSubNavbarWrapper = styled(SubNavbarWrapper)`
  margin-top: ${({ isNavbarHidden }) => (isNavbarHidden ? '0' : '80px')};
  ${media.desktop`
    margin-top: ${({ isNavbarHidden }) => (isNavbarHidden ? '0' : '50px')};    
  `}
`;

export const AppWrapper = styled.main`
  width: 100%;
  /* min-height: 100vh; */
  background: ${colors.lightGrey};
  max-width: 100%;
`;

if (!import.meta.env.PROD) {
  AppWrapper.displayName = 'AppWrapper';

  AppWrapper.defaultProps = {
    'aria-label': 'AppWrapper',
  };

  SubNavbarWrapper.displayName = 'SubNavbarWrapper';

  SubNavbarWrapper.defaultProps = {
    'aria-label': 'SubNavbarWrapper',
  };

  AppWrapper.displayName = 'AppWrapper';
}
